import { faGripVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback } from "react";
import { Button, ButtonGroup, ButtonToolbar } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { QuestionIcon } from "../../../../utils/QuestionUtils";
import questionTypes from "./questionTypes";

/**
 * Component which displays set of predefined question types to be dragged onto pages.
 * Toolbox contains e.g. Radio, Text, Checkbox etc. question types.
 */
const ToolboxPanel = () => {
  const intl = useIntl();

  const handleDragStart = useCallback((questionType, event) => {
    const dragData = JSON.stringify({
      type: "question",
      questionType: questionType
    });
    event.dataTransfer.setData("text", dragData);
  }, []);

  return (
    <ButtonToolbar>
      <ButtonGroup className="w-100 gap-sm" vertical>
        {questionTypes
          .filter((e) => !e.excludeFromToolbox)
          .map((questionType) => (
            <ButtonGroup key={questionType.type}>
              <Button className="text-start w-100">
                <QuestionIcon className="me-2" type={questionType.type} />
                <FormattedMessage id={questionType.toolboxComponent} />
              </Button>
              <Button
                title={intl.formatMessage({ id: "app.common.action.move" })}
                variant="secondary"
                draggable
                onDragStart={(e) => handleDragStart(questionType.type, e)}
              >
                <FontAwesomeIcon icon={faGripVertical} />
              </Button>
            </ButtonGroup>
          ))}
      </ButtonGroup>
    </ButtonToolbar>
  );
};

export default ToolboxPanel;
